import { api } from "./client";

export interface AppConfig {
  allowed_models: string[];
  default_model: string;
}

export async function fetchConfig(): Promise<AppConfig> {
  const { data } = await api.get<AppConfig>("/config");
  return data;
}
